import { render, staticRenderFns } from "./TestOnBoarding.vue?vue&type=template&id=4d060df1&scoped=true"
import script from "./TestOnBoarding.vue?vue&type=script&lang=js"
export * from "./TestOnBoarding.vue?vue&type=script&lang=js"
import style0 from "./TestOnBoarding.vue?vue&type=style&index=0&id=4d060df1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d060df1",
  null
  
)

export default component.exports